import { render, staticRenderFns } from "./DeclarationApproval.vue?vue&type=template&id=550b5e3a&"
import script from "./DeclarationApproval.vue?vue&type=script&lang=js&"
export * from "./DeclarationApproval.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationApproval.vue?vue&type=style&index=0&id=550b5e3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports